const LoginType = {
    BITKUB_NEXT: "bitkub_next",
    METAMASK: "metamask"
}

export default LoginType;